enum UserRoles {
  DesignEngineer = "Isaac.DesignEngineer",
  CADDesigner = "Isaac.CADDesigner",
  Reader = "Isaac.Reader",
}

export default UserRoles;
